import * as React from 'react'

interface IProps {
	title?: React.ReactNode
	contentClasses?: string
	className?: string
	headerRight?: JSX.Element
	style?: React.CSSProperties
	children?: React.ReactNode
}

export default class Panel extends React.PureComponent<IProps> {
	static defaultProps = {
		title: '',
		contentClasses: ''
	}

	render() {
		const { title, children, contentClasses, headerRight, style, className } = this.props

		return (
			<div className={className ? `panel ${className}` : 'panel'} style={style}>
				{(title || headerRight) && <div className='panel-header'>
					<div>
						{title}
					</div>

					{headerRight && <div>{headerRight}</div>}
				</div>}

				<div className={`panel-content ${contentClasses}`}>
					{children}
				</div>
			</div>
		)
	}
}